// extracted by mini-css-extract-plugin
export default {"root":"TwitterAudiencePublishList_root__tQvp3","pointer":"TwitterAudiencePublishList_pointer__T0u-w"};